import NewUserRegistrationComponent from './components/new_user_registration';
import NewUserRegistrationModule from './store';
import store from '~/base_store';
import { initializeComponents } from "~/utils/bundle_utils";

$(() => {
    store.registerModule('newUserRegistrationForm', NewUserRegistrationModule);

    const relKey = $('#new-user-registration').data('relkey');
    const token = $('#new-user-registration').data('token');
    const isCreating = $('#new-user-registration').data('is-creating');
    NewUserRegistrationModule.mutations.updateFormData(NewUserRegistrationModule.state, {
        rel_key: relKey,
        token,
        is_creating: isCreating
    });

    const agentEmail = $('#new-user-registration').data('agent-email-address');
    NewUserRegistrationModule.mutations.updateAgentEmailAddress(NewUserRegistrationModule.state, agentEmail);

    const proposedProfile = $('#new-user-registration').data('proposed-agent-profile');
    NewUserRegistrationModule.mutations.updateFormWithProposedProfile(NewUserRegistrationModule.state, proposedProfile);

    initializeComponents('#new-user-registration', NewUserRegistrationComponent);
});
